import _toConsumableArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _createForOfIteratorHelper from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import _variables from "@/styles/variables.scss";
import { resolve } from "path";
export default {
  components: {},
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission_routes"])), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      //   const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      //   if (meta.activeMenu) {
      //     return meta.activeMenu
      //   }
      var path = route.path;
      if (path.toLowerCase() === "/home") {
        path = "/";
      }
      var _iterator = _createForOfIteratorHelper(this.permission_routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.path !== "/" && path.includes(item.path)) {
            path = item.path;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.setSildeBarRoutes(path);
      return path;
    },
    variables: function variables() {
      return _variables;
    }
  }),
  mounted: function mounted() {
    // this.setSildeBarRoutes(this.activeMenu)
  },
  methods: {
    handleSelectMenu: function handleSelectMenu(index, indexPath) {
      this.setSildeBarRoutes(index);
    },
    setSildeBarRoutes: function setSildeBarRoutes(indexPath) {
      var permissionRoutes = this.permission_routes;
      var sildeRoutes = [];
      if (indexPath === "/") {
        var effectRoutes = permissionRoutes.filter(function (item) {
          return item.path !== indexPath && !item.hidden;
        });
        if (effectRoutes && effectRoutes.length > 0) {
          var _effectRoutes = _slicedToArray(effectRoutes, 1),
            defaultTopRoute = _effectRoutes[0];
          indexPath = defaultTopRoute.path;
          sildeRoutes.push.apply(sildeRoutes, _toConsumableArray(defaultTopRoute.children));
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(permissionRoutes),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            if (indexPath === item.path && item.children) {
              sildeRoutes.push.apply(sildeRoutes, _toConsumableArray(item.children));
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      // repair parent route path
      sildeRoutes.map(function (item) {
        return item.path = resolve(indexPath, item.path);
      });
      this.$store.commit("permission/SET_SILDEBAR_ROUTES", sildeRoutes);
    }
  }
};